import React from "react";
import { IStringLocalizer } from "../../../utilities/IStringLocalizer";

const revertIconSrc = "/images/ai-answer-metadata/revert-icon.svg";

interface AIAnswerMetadataRevertButtonProps {
    localizer: IStringLocalizer;
    isModifiedValue: boolean;
    isDisabled: boolean;
    onRevertClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const AIAnswerMetadataRevertButton: React.FC<AIAnswerMetadataRevertButtonProps> = ({
    localizer,
    isModifiedValue,
    isDisabled,
    onRevertClick
}) => {
    if (!isModifiedValue) {
        return null;
    }

    return (
        <button
            type="button"
            className="btn btn-link btn-xs ai-answer-field__revert-button"
            onClick={onRevertClick}
            title={localizer.localizeString("Reset to AI Suggestion")}
            aria-label={localizer.localizeString("Reset to AI Suggestion")}
            aria-disabled={isDisabled}
            disabled={isDisabled}
        >
            <img src={revertIconSrc} className="ai-answer-field__revert-icon" aria-hidden="true" alt="" />
        </button>
    );
};

export default AIAnswerMetadataRevertButton;
